import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { Location } from "app/common/location";
import { Incident, User, Doctor } from "app/shared/shared.module";
import { DoctorService } from "app/doctor/doctor.service";
import { Subscription } from "rxjs/Subscription";
import { GUID } from "app/brightserve/brightserve.module";
import { NotificationsService } from "angular2-notifications";
import { SharedCommonService } from "app/shared/shared-common.service";

@Component({
    selector: 'app-doctor-profile',
    templateUrl: './doctor-profile.component.html',
    styleUrls: ['./doctor-profile.component.css']
})
export class DoctorProfileComponent implements OnInit {

    counto1: any;
    counto2: any;
    counto3: any;

    Step: number = 50;
    Duration: number = 0.5;

    Editable: boolean = false;
    Id: GUID;
    User: Doctor;
    EditUser: Doctor = new Doctor();

    ChangePassword: any = {
        Id : GUID,
        CurrentPassword: "",
        NewPassword: "",
        NewPasswordConfirm: "",
    };

    passwordChangeForm;

    sub: Subscription;
    GetDoctorDetailsByIdSubscription: Subscription;
    SubmitDetailsChangeSubscription: Subscription;
    ChangePasswordSubscription: Subscription;
    NeedsToSpecifyCurrentPassword: boolean;

    constructor(private doctorService: DoctorService, private sharedCommonService: SharedCommonService, private route: ActivatedRoute, private router: Router, private _notification: NotificationsService) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            if (params && params['id']) {
                if (params['id'] == "details") {
                    this.GetCurrentUser();
                } else {
                    this.Id = params['id'];
                    this.GetUserById(this.Id);
                }
            }
            else
                this.GetCurrentUser();
        }); 
    };

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetDoctorDetailsByIdSubscription != null) {
            this.GetDoctorDetailsByIdSubscription.unsubscribe();
        }
    }

    GetCurrentUser() {
        this.GetDoctorDetailsByIdSubscription = this.doctorService.GetCurrentDoctorDetails().subscribe(user => {
            this.sharedCommonService.GetUserDetails().subscribe((res) => {
                this.Editable = true;
                this.User = user;
                this.EditUser = new Doctor(this.User);
                this.NeedsToSpecifyCurrentPassword = true;
            });
        }, err => {
            this._notification.error("Error Getting Details.", "There was an error getting your details, please ensure you are using a doctors account.");
            this.router.navigateByUrl('/dashboard');
        });
    }
    GetUserById(id) {
        this.GetDoctorDetailsByIdSubscription = this.doctorService.GetDoctorDetailsById(id).subscribe(user => {
            this.sharedCommonService.GetUserDetails().subscribe((res) => {
                if (this.Id == res.User.Id || (res.User.Privileges & 514))
                    this.Editable = true;
                this.User = user;
                this.EditUser = new Doctor(this.User);
                this.NeedsToSpecifyCurrentPassword = this.Id == res.User.Id;;
            });
        }, err => {
            this._notification.error("Error Getting Details.", "There was an error the details for this doctor, please ensure you are using an admin account.");
            this.router.navigateByUrl('/dashboard');
        });
    }

    SubmitDetailsChange() {
        this.SubmitDetailsChangeSubscription = this.doctorService.ChangeDetails(this.EditUser).subscribe((res) => {
            this._notification.success("Details Changed", "Doctor details changed successfully.");
            this.User = res;
            this.EditUser = new Doctor(this.User);
        }, (err) => {
            if (err && err.status == 400 && err.error && Object.keys(err.error).length) {
                for (var k in err.error) {
                    if (err.error[k] && err.error[k].length) {
                        var text = "";
                        for (var i = 0; i < err.error[k].length; i++) {
                            text += err.error[k][i];
                        }
                        this._notification.error(k.split(".").join(" ") + " Fail", text);
                    }

                }
            } else {
                console.log(err);
                this._notification.error("Detail Change Unsuccessful", "Detail change was unsuccessful, please try again.");
            }
        });
    }

    ResetDetails() {
        this.EditUser = new Doctor(this.User);
    }

    SubmitPasswordChange() {
        this.ChangePassword.Id = this.User.Id;
        this.ChangePasswordSubscription = this.doctorService.ChangePassword(this.ChangePassword).subscribe((res) => {
            this._notification.success("Password Changed", "Password changed successfully.")
            this.User = res;
            this.EditUser = new Doctor(this.User);
        }, (err) => {
            if (err && err.status == 400 && err.error && Object.keys(err.error).length) {
                for (var k in err.error) {
                    if (err.error[k] && err.error[k].length) {
                        var text = "";
                        for (var i = 0; i < err.error[k].length; i++) {
                            text += err.error[k][i];
                        }
                        this._notification.error(k + " Fail", text);
                    }
                        
                }
            } else {
                console.log(err);
                this._notification.error("Password Change Fail", "Password changed failed.");
            }
        });
    };

    ClearPasswordChange() {
        this.ChangePassword = {
            CurrentPassword: "",
            NewPassword: "",
            NewPasswordConfirm: "",
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/doctor/profile/doctor-profile.component.ts